import { render } from "./v1_idx.vue?vue&type=template&id=2c429f96"
import script from "./v1_idx.vue?vue&type=script&lang=js"
export * from "./v1_idx.vue?vue&type=script&lang=js"

import "./v1_idx.vue?vue&type=style&index=0&id=2c429f96&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__